import { getItem } from '@utils/localStorage'

export const IS_CONTAINER_APP_STORAGE_KEY = 'is-container-app'
/**
 * Are we able to tell if the container app is running?
 */
export const canCheckForContainerApp = (): boolean => {
    if (typeof window === 'undefined') {
        return false
    }

    return Boolean(window.navigator.userAgent) || Boolean(getItem(IS_CONTAINER_APP_STORAGE_KEY))
}

/**
 * Whether the Container App is currently running. This function is susceptible to spoofing.
 */
export const isContainerApp = (): boolean => {
    if (!canCheckForContainerApp()) {
        return false
    }

    return (
        // Example UA, ends with `[InterNations app:ContainerApp os:Android/1.2 env:prod ver:1]`
        window.navigator.userAgent.includes('app:ContainerApp') || Boolean(getItem(IS_CONTAINER_APP_STORAGE_KEY))
    )
}
